import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import AuthorizeRoute from '../api-authorization/AuthorizeRoute';
import { HandbookPage } from './HandbookPage';
import { HandbookEditor } from './HandbookEditor';
import { HandbookAdminList } from './HandbookAdminList';

function HandbookRouter() {
	let match = useRouteMatch();

	return (
		<Switch>
			<AuthorizeRoute exact path={`${match.path}/admin`} component={HandbookEditor} />
			<AuthorizeRoute path={`${match.path}/admin/legacy`} component={HandbookAdminList} />
			{/* support optional language segment, e.g. /handbook/cy */}
			<Route path={`${match.path}/:lang?`} component={HandbookPage} />
		</Switch>
	);
}

export default HandbookRouter;
